import { Box, Button } from "@mui/material";

import { InputField } from "../../styles/customStyles/InputField";
import React from "react";
import { useMemo } from "react";

const FilterInput = ({ filterText, onFilter, onClear, filterBy }) => {
        // const filterPlaceHolder = `Filter By ${filterBy.charAt(0).toUpperCase() + filterBy.substring(1).replace(/_/g, " ")}`
        const filterPlaceHolder = `Search`;

    return (
        <>
        <Box sx={{ display: "inline-flex", gap: "1rem", alignItems: "center" }}>
            <InputField
                id="search"
                type="text"
                placeholder={filterPlaceHolder}
                aria-label="Search Input"
                value={filterText}
                onChange={onFilter}
            />
            <Button size="small" color="error" type="button" onClick={onClear}>
                Clear
            </Button>
            </Box>
        </>
    );
};

const FilterDataComponent = (props) => {
    const {
        filterText,
        setResetPaginationToggle,
        setFilterText,
        resetPaginationToggle,
    } = props;
    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterInput
                onFilter={(e) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterText, resetPaginationToggle]);

    return subHeaderComponentMemo;
};

export default FilterDataComponent;
